import React, { CSSProperties } from 'react';
import { theme } from '../constants';

interface StatusModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  message: string;
  containerStyle?: CSSProperties;
  titleStyle?: CSSProperties;
  messageStyle?: CSSProperties;
  renderMessage?: React.ReactNode;
}

const StatusModal: React.FC<StatusModalProps> = ({
  isOpen,
  onClose,
  title,
  message,
  containerStyle,
  titleStyle,
  messageStyle,
  renderMessage
}) => {
  const modalStyle: CSSProperties = {
    display: isOpen ? 'flex' : 'none',
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  };

  const modalContainerStyle: CSSProperties = {
    position: 'relative',
    width: '90%',
    maxWidth: '500px',
    maxHeight: '80vh',
    backgroundColor: theme.colors.paleYellow,
    borderRadius: '32px',
    padding: '20px',
    overflowY: 'auto',
    ...containerStyle,
  };

  const closeButtonStyle: CSSProperties = {
    position: 'absolute',
    top: '20px',
    right: '20px',
    fontSize: '24px',
    color: '#333',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    zIndex: 1,
  };

  const defaultTitleStyle: CSSProperties = {
    fontSize: '20px',
    marginBottom: '16px',
    color: theme.colors.textColor,
    wordBreak: 'break-word',
    ...titleStyle,
  };

  const defaultMessageStyle: CSSProperties = {
    color: theme.colors.textColor,
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    whiteSpace: 'pre-wrap',
    ...messageStyle,
  };

  const contentStyle: CSSProperties = {
    textAlign: 'center',
    padding: '20px',
    fontFamily: 'Poppins-Regular',
    maxHeight: 'calc(80vh - 40px)',
    overflowY: 'auto',
  };

  // Function to format wallet addresses
  const formatMessage = (msg: string) => {
    // Split the message into parts
    const parts = msg.split(/(\b0x[a-fA-F0-9]{40}\b)/g);

    return parts.map((part) => {
      // If this part is a wallet address, format it
      if (/^0x[a-fA-F0-9]{40}$/.test(part)) {
        return `${part.slice(0, 6)}...${part.slice(-4)}`;
      }
      return part;
    }).join('');
  };

  return (
    <div style={modalStyle}>
      <div style={modalContainerStyle}>
        <button onClick={onClose} style={closeButtonStyle}>×</button>
        <div style={contentStyle}>
          <h3 style={defaultTitleStyle}>
            {title}
          </h3>
          {renderMessage ? (
            <div style={{ ...defaultMessageStyle }}>
              {renderMessage}
            </div>
          ) : (
            <div style={defaultMessageStyle}>
              {formatMessage(message).split('\n\n').map((paragraph, index) => (
                <p key={index} style={{ marginBottom: index === 0 ? '1em' : 0 }}>
                  {paragraph}
                </p>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StatusModal;